<template>
  <a-modal
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :visible="visible"
    :title="modalTitle"
    @ok="submitForm"
    @cancel="handleCancel"
  >
    <a-form
      :form="form"
      :layout="formLayout"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-item label="角色名称">
        <a-input
          :disabled="nameDisabled"
          v-decorator="[
            'name',
            {
              initialValue: tableRow.name,
              rules: [{ required: true, message: '请输入角色名称!' }],
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="角色描述">
        <a-input
          v-decorator="[
            'description',
            {
              initialValue: tableRow.description,
              rules: [{ required: true, message: '请输入角色描述!' }],
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="权限级别">
        <a-select
          v-decorator="[
            'permissionLevel',
            {
              initialValue: tableRow.permissionLevel,
              rules: [{ required: true, message: '请选择权限级别!' }],
            },
          ]"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in selectList"
            :key="item.level"
            :value="item.level"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="权限配置">
        <a-tree
          v-decorator="['permissionIds']"
          :autoExpandParent="true"
          checkable
          :tree-data="treeData"
          :defaultExpandAll="true"
          v-model="checkedKeys"
          :replace-fields="replaceFields"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { getPermissionLevels, getMenuList, addRole } from '../api'

export default {
  data() {
    return {
      modalTitle: '新增角色',
      visible: false,
      confirmLoading: false,
      formLayout: 'horizontal',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
      selectList: [],
      checkedKeys: ['912618904297144322', '912516365942890497'],
      treeData: [],
      replaceFields: {
        children: 'children',
        title: 'name',
        key: 'id',
      },
      username: {
        value: 'benjycui',
      },
      tableRow: {},
      treeParentIds: [],
    }
  },
  props: ['checkRoleNameInRange'],
  watch: {
    treeData(newVal) {
      let parentIds = this.collectParentIds(newVal, [])
      this.treeParentIds = parentIds
    },
  },
  computed: {
    nameDisabled() {
      const tableRow = this.tableRow
      const roleName = tableRow && tableRow.name
      return this.checkRoleNameInRange(roleName)
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'createForm' })
  },
  mounted() {
    this._getPermissionLevels()
    this._getMenuList()
  },
  methods: {
    // 返回参数中有带 children 的节点的 id 集合
    collectParentIds(list, parentIds) {
      list.forEach(item => {
        if (item.children && item.children.length) {
          parentIds.push(item.id)
          this.collectParentIds(item.children, parentIds)
        }
      })
      return parentIds
    },

    // 权限配置Tree树-请求数据
    async _getMenuList() {
      try {
        const { data } = await getMenuList()
        this.treeData = data
      } catch (err) {
        console.log(err)
      }
    },
    // 权限级别-请求数据
    async _getPermissionLevels() {
      try {
        const { data } = await getPermissionLevels()
        this.selectList = data
      } catch (err) {
        console.log(err)
      }
    },
    // 新增
    add() {
      this.modalTitle = '新增角色'
      this.visible = true
      this.form.resetFields()
      this.tableRow = {}
      this.checkedKeys = []
      this.id = ''
    },
    // 维护
    edit(tableRow) {
      this.modalTitle = '编辑角色'
      this.visible = true
      this.tableRow = tableRow
      const { id, permissionIds } = tableRow
      this.id = id
      this.checkedKeys = permissionIds
    },
    // 取消
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    // 提交数据
    submitForm(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          let data = Object.assign({}, values)
          data.permissionIds = this.checkedKeys.filter(key => {
            // 把父节点删除掉
            return !this.treeParentIds.includes(key)
          })
          data.id = this.id
          //this.$emit('create', data)
          addRole(data).then(() => {
            if (!err) {
              this.handleCancel()
              this.$emit('getTableData')
            }
          })
        }
      })
    },
  },
}
</script>
